import SparkleIcon from '../../../assets/icons/aiChat/SparkleIcon';
import { useAIChat } from './AIChatContext';

export default function AskAIButton() {
  const { setOpen, isDashboardPage } = useAIChat();

  if (!isDashboardPage) return null;

  return (
    <button
      type="button"
      onClick={() => setOpen(true)}
      className="hidden items-center gap-2 rounded-full cursor-pointer bg-gradient-to-r from-violet-500 to-indigo-600 px-4 py-2.5 text-sm font-semibold text-white shadow-[0_4px_14px_rgba(99,102,241,0.35)] transition hover:from-violet-600 hover:to-indigo-700 hover:shadow-[0_6px_18px_rgba(99,102,241,0.4)] focus:outline-none focus-visible:ring-2 focus-visible:ring-violet-400 focus-visible:ring-offset-2 md:inline-flex"
    >
      <SparkleIcon className="h-5 w-5 shrink-0" />
      Ask AI
    </button>
  );
}
